import React from 'react';
import PropTypes from 'prop-types';
import defaultPropTypes from '../../../utils/prop-types';
import { withTempSelection } from '../../../utils/convenience';
var ListItem = function ListItem(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "locations-list-item ".concat(props.layoutType, " ").concat(props.index % 2 ? 'even' : 'odd', " ").concat(props.location.equals(props.selectedLocation) || props.location.equals(props.tempSelectedLocation) ? 'selected' : ''),
    onClick: function onClick(e) {
      var shouldDispatchHighlightTrackingEvent = e.target.id !== 'info-button';
      props.onSelectLocation(props.location, shouldDispatchHighlightTrackingEvent);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.code === "".concat(props.index + 1)) {
        props.onOpenLocation(props.location);
      }
    },
    role: "button",
    tabIndex: props.index
  }, /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("strong", null, props.location.Name)), /*#__PURE__*/React.createElement("div", {
    className: "address"
  }, props.location.FormattedAddress), props.location.Phone && /*#__PURE__*/React.createElement("div", {
    className: "phone"
  }, props.settings.dictionary.phone, ":", ' ', /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(props.location.Phone),
    onClick: function onClick() {
      return props.onPhoneClick(props.location);
    }
  }, props.location.Phone)), /*#__PURE__*/React.createElement("div", {
    className: "opening-hours"
  }, props.location.OpeningHours), /*#__PURE__*/React.createElement("div", {
    className: "distance"
  }, /*#__PURE__*/React.createElement("i", null, "".concat(props.distance, " ").concat(props.settings.Unit)))), /*#__PURE__*/React.createElement("div", {
    className: "cta"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button",
    id: "info-button",
    onClick: function onClick(e) {
      props.onOpenLocation(props.location, e);
      window.DGS.Event.getInstance().trigger('trackLocationsClinicClick', props.location.Name, props.location.PostalCode);
    }
  }, props.settings.dictionary.info))));
};
export default withTempSelection(ListItem);
ListItem.propTypes = {
  settings: defaultPropTypes.settings.isRequired,
  location: defaultPropTypes.location.isRequired,
  distance: PropTypes.string.isRequired,
  tempSelectedLocation: defaultPropTypes.location.isRequired,
  selectedLocation: defaultPropTypes.location.isRequired,
  onSelectLocation: defaultPropTypes.func.isRequired,
  onOpenLocation: defaultPropTypes.func.isRequired,
  onPhoneClick: PropTypes.func,
  layoutType: defaultPropTypes.layoutType.isRequired,
  index: PropTypes.number.isRequired
};
ListItem.defaultProps = {
  onPhoneClick: function onPhoneClick() {}
};